"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const event_agent_js_1 = __importDefault(require("@hotmart/event-agent-js"));
class DatahubBulkDrippingService {
    constructor() {
        this.system = constants_1.SYSTEMS.APP_CLUB_ADMIN;
        this.entity = 'dripping';
        this.sendNewEvent = (event) => {
            this.sendEvent('new_single', event);
        };
        this.sendCancelNewEvent = (event) => {
            this.sendEvent('cancel_new_single', event);
        };
        this.sendCancelEditEvent = (event) => {
            this.sendEvent('cancel_edit', event);
        };
        this.sendRemoveEvent = (event) => {
            this.sendEvent('remove_single', event);
        };
        this.sendCancelRemoveEvent = (event) => {
            this.sendEvent('cancel_remove_single', event);
        };
        this.sendEvent = (action, event) => {
            event_agent_js_1.default.send({
                system: this.system,
                entity: this.entity,
                action,
                event
            });
        };
    }
}
exports.default = new DatahubBulkDrippingService();
